class VuexService {
    /**
     * Returns the global Vuex store for the application.
     * Prefer using this service over directly accessing the window object.
     *
     * @returns {import('vuex').Store}
     */
    getStore() {
        if (typeof window === 'undefined') {
            // Perhaps this code is running in a unit test?
            throw new Error('window is not defined');
        }

        if (!window.rootVueStore) {
            throw new Error('window.rootVueStore is not defined');
        }

        return window.rootVueStore;
    }

    commit(mutationName, payload) {
        this.getStore().commit(mutationName, payload);
    }

    /**
     * Read the current value of a Vuex getter.
     *
     * @param {string} getterName
     *
     * @returns {*}
     */
    getter(getterName) {
        return this.getStore().getters[getterName];
    }
}

module.exports = VuexService;
